import React, { useCallback } from 'react'; // eslint-disable-line
import { useDispatch } from 'react-redux';
import {
  func, number, oneOf, string, arrayOf, any, bool, shape,
} from 'prop-types';
import { resizePanel } from '../../store/actions/main';
import TranscriptList from './components/TranscriptList';
import './styles.scss';

const TranscriptPanel = ({
  assetId,
  assetName,
  panelWidth,
  videoCurrentTime,
  setVideoPlayerCurrentTime,
  transcribing = 'skipped',
  videoAnalyzing = 'skipped',
  transcript,
  transcriptLang = 'en',
  videoAi,
  assetSize,
  assetMimeType,
  keywords = [],
  activeRevisionID = null,
  isLoaded = false,
  manageTranscriptPermission = false,
  addonsFeatures = {},
}) => {
  const dispatch = useDispatch();
  const handleResize = useCallback(
    (event) => dispatch(resizePanel(event, 'previewView.right')),
    [dispatch],
  );

  return (
    <div className="transcriptionsPanel" style={{ width: panelWidth }}>
      <div
        role="presentation"
        className="resizer"
        onMouseDown={handleResize}
      />
      <TranscriptList
        videoCurrentTime={videoCurrentTime}
        setVideoPlayerCurrentTime={setVideoPlayerCurrentTime}
        transcript={transcript}
        assetId={assetId}
        activeRevisionID={activeRevisionID}
        assetName={assetName}
        assetSize={assetSize}
        assetMimeType={assetMimeType}
        keywords={keywords}
        lang={transcriptLang}
        manageTranscriptPermission={manageTranscriptPermission}
        transcribing={transcribing}
        videoAnalyzing={videoAnalyzing}
        videoAi={videoAi}
        isLoaded={isLoaded}
        addonsFeatures={addonsFeatures}
      />
    </div>
  );
};

TranscriptPanel.propTypes = {
  assetId: string.isRequired,
  assetName: string.isRequired,
  panelWidth: number.isRequired,
  setVideoPlayerCurrentTime: func.isRequired,
  videoCurrentTime: number.isRequired,
  transcribing: oneOf(['skipped', 'waiting', 'running', 'complete', 'failed', 'rejected']),
  transcript: arrayOf(any),
  transcriptLang: string,
  activeRevisionID: string,
  isLoaded: bool,
  manageTranscriptPermission: bool,
  videoAi: any,
  keywords: arrayOf(any),
  addonsFeatures: shape({
    aiKit: shape({
      id: string,
    }),
  }),
};

export default TranscriptPanel;
